(function () {
  "use strict";

  function pageSize() {
    return window.matchMedia("(max-width: 820px)").matches
      ? 5
      : 12;
  }

  function initImportedReviews(section) {
    if (!section) return;

    if (section.dataset.trImportedReviewsReady === "true") {
      return;
    }

    section.dataset.trImportedReviewsReady = "true";

    var list = section.querySelector("[data-tr-review-list]");

    if (!list) return;

    /*
     * Ausschließlich serverseitig gerenderte Kundenbewertungen behalten.
     * Alte Testzeilen und alte Trundes-Team-Inhalte werden entfernt.
     */
    Array.prototype.slice.call(list.children).forEach(function (child) {
      if (!child.hasAttribute("data-tr-imported-review")) {
        child.remove();
      }
    });

    section
      .querySelectorAll(
        ".tr-product__team-inline-notes," +
        "[data-tr-team-inline-notes]"
      )
      .forEach(function (element) {
        element.remove();
      });

    var rows = Array.prototype.slice.call(
      list.querySelectorAll("[data-tr-imported-review]")
    );

    if (!rows.length) return;

    var searchInput = section.querySelector(
      "[data-tr-review-search]"
    );

    var ratingSelect = section.querySelector(
      "[data-tr-review-filter-rating]"
    );

    var localeSelect = section.querySelector(
      "[data-tr-review-filter-locale]"
    );

    var sortSelect = section.querySelector(
      "[data-tr-review-sort]"
    );

    var resultsLine = section.querySelector(
      ".tr-product__review-results p"
    );

    if (searchInput) {
      searchInput.disabled = false;
    }

    if (ratingSelect) {
      ratingSelect.disabled = false;
    }

    if (localeSelect) {
      localeSelect.disabled = true;
      localeSelect.title =
        "Locale data was not supplied with these reviews.";

      var localeLabel = localeSelect.closest("label");

      if (localeLabel) {
        localeLabel.hidden = true;
      }
    }

    if (sortSelect) {
      sortSelect.disabled = false;
    }

    var loadMore = document.createElement("button");

    loadMore.type = "button";
    loadMore.className =
      "tr-product__write-review tr-nova-review-more";
    loadMore.setAttribute(
      "data-tr-review-load-more",
      "true"
    );

    loadMore.style.display = "block";
    loadMore.style.margin = "28px auto 0";

    list.insertAdjacentElement("afterend", loadMore);

    var shown = pageSize();

    function originalOrder(row) {
      return Number(row.dataset.reviewOrder || 0);
    }

    function selectedRows() {
      var query = searchInput
        ? searchInput.value.trim().toLowerCase()
        : "";

      var rating = ratingSelect
        ? ratingSelect.value
        : "";

      var sort = sortSelect
        ? sortSelect.value
        : "featured";

      var filtered = rows.filter(function (row) {
        var matchesSearch =
          !query ||
          String(row.dataset.search || "").indexOf(query) !== -1;

        var matchesRating =
          !rating ||
          String(row.dataset.rating) === String(rating);

        return matchesSearch && matchesRating;
      });

      if (sort === "highest") {
        filtered.sort(function (a, b) {
          return (
            Number(b.dataset.rating) -
              Number(a.dataset.rating) ||
            originalOrder(a) - originalOrder(b)
          );
        });
      } else if (sort === "lowest") {
        filtered.sort(function (a, b) {
          return (
            Number(a.dataset.rating) -
              Number(b.dataset.rating) ||
            originalOrder(a) - originalOrder(b)
          );
        });
      } else {
        filtered.sort(function (a, b) {
          return originalOrder(a) - originalOrder(b);
        });
      }

      return filtered;
    }

    function render() {
      var filtered = selectedRows();

      var nonMatching = rows.filter(function (row) {
        return filtered.indexOf(row) === -1;
      });

      filtered
        .concat(nonMatching)
        .forEach(function (row) {
          list.appendChild(row);
          row.hidden = true;
        });

      var displayed = filtered.slice(0, shown);

      displayed.forEach(function (row) {
        row.hidden = false;
      });

      if (resultsLine) {
        resultsLine.innerHTML =
          '<span data-tr-review-visible>' +
          displayed.length +
          "</span> of " +
          filtered.length +
          " reviews";
      }

      var remaining = filtered.length - displayed.length;

      loadMore.hidden = remaining <= 0;

      loadMore.textContent =
        remaining > 0
          ? "Show more reviews (" + remaining + ")"
          : "All reviews shown";
    }

    function resetAndRender() {
      shown = pageSize();
      render();
    }

    if (searchInput) {
      searchInput.addEventListener(
        "input",
        resetAndRender
      );
    }

    if (ratingSelect) {
      ratingSelect.addEventListener(
        "change",
        resetAndRender
      );
    }

    if (sortSelect) {
      sortSelect.addEventListener(
        "change",
        resetAndRender
      );
    }

    section
      .querySelectorAll("[data-tr-review-bar]")
      .forEach(function (button) {
        button.disabled = false;

        button.addEventListener("click", function () {
          if (ratingSelect) {
            var rating = String(
              button.dataset.trReviewBar || ""
            );

            ratingSelect.value =
              ratingSelect.value === rating
                ? ""
                : rating;
          }

          resetAndRender();
        });
      });

    loadMore.addEventListener("click", function () {
      shown += pageSize();
      render();
    });

    /*
     * Verhindert, dass eine alte gecachte Datei später erneut
     * Trundes-Team-Testzeilen in die Liste einsetzt.
     */
    var cleanupObserver = new MutationObserver(function () {
      Array.prototype.slice.call(list.children).forEach(
        function (child) {
          if (
            !child.hasAttribute("data-tr-imported-review")
          ) {
            child.remove();
          }
        }
      );
    });

    cleanupObserver.observe(list, {
      childList: true
    });

    window.setTimeout(function () {
      cleanupObserver.disconnect();
    }, 10000);

    render();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll(".tr-product__reviews")
      .forEach(initImportedReviews);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAll(event.target);
    }
  );
})();

// Trundes compact mobile reviews version 6
